import React from 'react';

const WhereByIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="28"
      viewBox="0 0 21 28"
      fill="none"
    >
      <path
        d="M10.497 1.5C5.71917 1.5 1.84277 5.18949 1.84277 9.73358C1.84277 14.9622 7.61229 23.2481 9.73079 26.11C9.81872 26.2308 9.93398 26.3291 10.0671 26.3969C10.2003 26.4647 10.3476 26.5 10.497 26.5C10.6465 26.5 10.7938 26.4647 10.927 26.3969C11.0601 26.3291 11.1754 26.2308 11.2633 26.11C13.3818 23.2493 19.1513 14.9664 19.1513 9.73358C19.1513 5.18949 15.2749 1.5 10.497 1.5Z"
        stroke="#FEFEFE"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4971 13.039C12.0903 13.039 13.3818 11.7475 13.3818 10.1543C13.3818 8.56108 12.0903 7.26953 10.4971 7.26953C8.90386 7.26953 7.6123 8.56108 7.6123 10.1543C7.6123 11.7475 8.90386 13.039 10.4971 13.039Z"
        stroke="#FEFEFE"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default WhereByIcon;